module.exports = __webpack_public_path__ + "img/Meganisi.3eaeffe8.png";